import { atomWithStorage, createJSONStorage } from 'jotai/utils';

type ColumnOrderState = Record<string, string[]>;

const storage = createJSONStorage<ColumnOrderState>(() => localStorage);

export const $columnOrders = atomWithStorage<ColumnOrderState>(
  'datagrid-column-orders',
  {},
  storage,
  { getOnInit: true },
);
